export const sortBy = <T>(arr: T[], k: keyof T) =>
    arr.concat().sort((a, b) => (a[k] > b[k] ? 1 : a[k] < b[k] ? -1 : 0));

export const allRecordEquals = <T>(arr: T[]) => arr.every((val) => val === arr[0]);

export const removeDuplicate = <T>(arr: T[]): T[] => arr.filter((el, i, array) => array.indexOf(el) === i);
